import * as React from 'react'

/** A collection of html helpers */
export namespace Html {

    /**
     * Renders a div with the given content inside
     * @param content The content inside the div
     */
    export function renderDiv(content: string, className: string = "") {
        if (!content) {
            return null
        }

        if (content.substr(0, 4) === '<div') {
            return <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: content }}></div>
        }

        return <div className={className}>{content}</div>
    }

    /**
     * Renders a div with the given content inside
     * @param content The content inside the div
     */
    export function renderParagraph(content: string, className: string = "") {
        if (!content) {
            return null
        }

        if (content.trim().substr(0, 4) === '<div') {
            return <p className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: content }
            }></p >
        }

        return <div className={className}>{content}</div>
    }

    /**
     * Renders a div with the given content inside if it is html. Just the content if not
     * @param content The content inside the div
     */
    export function renderContent(content: string) {
        if (!content) {
            return null
        }

        if (content.trim().substr(0, 4) === '<div' || content.substr(0, 2) === '<p') {
            return <div className="rich-text" dangerouslySetInnerHTML={{ __html: content }}></div>
        }

        return content
    }

    export function isHtmlPrompt(message: string): boolean {
        if (message === null)
            return false;
        return message.substr(0, 4) === "<div";
    }

}